import AbstractCommand from "../../application/AbstractCommand";
import SkinKeyRegistry from "../../ui/SkinKeyRegistry";
import SystemMessage from "../model/SystemMessage";

export default class SystemMessageCommand extends AbstractCommand {
    constructor(dispatcher) {
        super(dispatcher)
    }

    execute(evt) {
        const data = evt.params.data;
        /** @type {SystemMessage} */
        const systemMessage = data.systemMessage;

        this.openPopup(SkinKeyRegistry.SYSTEM_MESSAGE_POPUP_SKIN, null, {
            priority: 9999,
            needsOverlay: false,
        }, {
            systemMessage
        });
    }
}